export default __webpack_public_path__ + "static/media/arras03.d4cb4a59.jpg";